import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b56ebb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-pagesettings" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data"),
  /*#__PURE__*/_createElementVNode("h2", null, "ATCS Help and Info")
], -1))
const _hoisted_3 = { class: "pagesettings-table" }
const _hoisted_4 = { class: "ls-table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["colspan"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { "data-label": "Page" }
const _hoisted_12 = { class: "two-lines" }
const _hoisted_13 = { "data-label": "Type" }
const _hoisted_14 = { "data-label": "Title" }
const _hoisted_15 = { class: "two-lines" }
const _hoisted_16 = { "data-label": "Internal Note" }
const _hoisted_17 = { class: "two-lines" }
const _hoisted_18 = { "data-label": "Status" }
const _hoisted_19 = { class: "checkbox-button" }
const _hoisted_20 = ["checked", "onChange"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show")
], -1))
const _hoisted_22 = { "data-label": "Actions" }
const _hoisted_23 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_HelpEditModal = _resolveComponent("HelpEditModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("div", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_6)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_8)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.pageSettingsList.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", {
                      colspan: _ctx.pageSettingsList.length
                    }, "No Records", 8, _hoisted_10)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.pageSettingsList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.pageSettingsList, (p) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(p?.page?.name ?? ''), 1)
                        ]),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(p?.contentType?.name ?? ''), 1),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(p?.title ?? ''), 1)
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(p?.internalNote ?? ''), 1)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: p.isShow,
                              onChange: $event => (_ctx.pageContentStatus(p, $event.srcElement.checked))
                            }, null, 40, _hoisted_20),
                            _hoisted_21
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.editPageSettings(p))
                          }, "Edit", 8, _hoisted_23)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showPopoverEdit)
      ? (_openBlock(), _createBlock(_component_HelpEditModal, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = $event => (_ctx.showPopoverEdit = false)),
          helpContent: _ctx.selectedPageSettings
        }, null, 8, ["helpContent"]))
      : _createCommentVNode("", true)
  ]))
}